import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';
import containsOrIsNode from '@cotyorg/ccx-utils/js/helpers/containsOrIsNode';
import { getDocument } from '@cotyorg/ccx-utils/js/helpers/globals';

export const getOnClick = ({ toggleFilterCategory, categoryName }) => () => {
  toggleFilterCategory(categoryName);
};

export const generateToggableClassNames = ({ isClosed } = {}) => (
  classNames('filter__dropdown-togglable', {
    'filter__dropdown-togglable--is-closed': isClosed,
    'filter__dropdown-togglable--is-overlayed': !isServer,
  })
);

// Need class so that we can use componentDidMount
// to provide progressive enhancement
// istanbul ignore next
class Dropdown extends PureComponent {
  componentDidMount() {
    const { toggleFilterCategory, categoryName, isClosed } = this.props;

    // Close the dropdowns in client-side JS so that they are
    // open by default in case JS fails
    if (!isServer && !isClosed) {
      toggleFilterCategory(categoryName);
    }

    if (!isServer) {
      getDocument().addEventListener('click', this.documentClickHandler, false);
    }
  }

  componentWillUnmount() {
    getDocument().removeEventListener('click', this.documentClickHandler, false);
  }

  documentClickHandler = ({ target }) => {
    const { isClosed, toggleFilterCategory, categoryName } = this.props;
    const shouldToggle = (
      !containsOrIsNode(this.wrapper, target) &&
      !isClosed
    );

    if (shouldToggle) {
      toggleFilterCategory(categoryName);
    }
  }

  render() {
    const {
      title,
      isClosed,
      toggleFilterCategory,
      categoryName,
      children,
      dropdownClosedIconSrc,
      dropdownOpenIconSrc,
    } = this.props;

    const iconSrc = isClosed ? dropdownClosedIconSrc : dropdownOpenIconSrc;

    return (
      <div ref={(el) => { this.wrapper = el; }} className="filter__dropdown cell auto">
        <IconButton
          extraClass="filter__dropdown-button align-justify"
          iconExtraClass="filter__dropdown-button-icon"
          iconSrc={iconSrc}
          iconAfterText
          onClick={getOnClick({ toggleFilterCategory, categoryName })}
        >
          {title}
        </IconButton>
        <div className={generateToggableClassNames({ isClosed })}>
          <div className="filter__dropdown-scrollable">
            { children }
          </div>
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  isClosed: PropTypes.bool,
  toggleFilterCategory: PropTypes.func.isRequired,
  categoryName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  dropdownClosedIconSrc: PropTypes.string.isRequired,
  dropdownOpenIconSrc: PropTypes.string.isRequired,
};

export default Dropdown;
